/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespIconBubbles_viewer$ref = any;
type PdpRespTradeIconBubbles_viewer$ref = any;
export type PdpRespIconBubblesWrapper_viewer$ref = any;
export type PdpRespIconBubblesWrapper_viewer = {
    readonly " $fragmentRefs": PdpRespIconBubbles_viewer$ref & PdpRespTradeIconBubbles_viewer$ref;
    readonly " $refType": PdpRespIconBubblesWrapper_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespIconBubblesWrapper_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespIconBubbles_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PdpRespTradeIconBubbles_viewer",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '50d384ae4d7efb2d8117904c0184cfaf';
export default node;
